import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query'
import waterSourceApi, { IWaterSource } from '@/api/config/waterSourceApi'

function useSearchWaterSource(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<IWaterSource>, any> {

  return useQuery(
    [queryKeys.waterSource, interfaceId, searchParams],
    async () => {
      const { data } = await waterSourceApi.getAll({
        ...searchParams,
        interfaceId,
      })

      if (!data) return null

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchWaterSource
